import React, { useState, useEffect } from 'react';
import { useQuery } from '/src/api';
import {
    useAuthContext,
    useCartContext,
    useModalsContext,
    useStoreConfigContext,
} from '/src/providers';
import {
    Modal,
    FormCheckoutAddress,
    Errors,
    H2,
} from '/src/components';
import graphQLQueries from './graph-ql-queries';

const ShippingAddress = ({ setShippingMethodsOnCart }) => {
    const { translate } = useStoreConfigContext();
    const { isAuth } = useAuthContext();
    const { hideModal } = useModalsContext();
    const {
        cart: {
            id,
        },
        isLoadingCart,
        setShippingAddressesOnCart,
        setBillingAddressOnCart,
    }  = useCartContext();
    const {
        data: dataCountries,
        isLoading: isLoadingCountries,
        runQuery: countriesRunQuery,
    } = useQuery({
        data: [],
        query: graphQLQueries.countries,
        queryKey: ['countries'],
    });
    const [errors, setErrors] = useState(null);
    const isLoading = isLoadingCountries || isLoadingCart;

    const setAddressOnCart = address => setShippingAddressesOnCart({
        input: {
            cart_id: id,
            shipping_addresses: [{ address }]
        }
    }).then(response => {
        if (!isAuth) {
            return setBillingAddressOnCart({
                input: {
                    cart_id: id,
                    billing_address: {
                        same_as_shipping: true,
                    }
                },
            })
        }
        return response;
    }).then(() => {
        setShippingMethodsOnCart();
        hideModal();
    }).catch(errors => setErrors(errors));

    useEffect(() => {
        countriesRunQuery();
    },[]);

    return (
        <Modal toggle={hideModal}>
            <H2>{translate('Delivery address')}</H2>
            <Errors errors={errors} />
            <FormCheckoutAddress
                setAddressOnCart={setAddressOnCart}
                isAuth={isAuth}
                dataCountries={dataCountries?.filter(({ available_for_shipping }) => available_for_shipping )}
                isLoading={isLoading}
            />
        </Modal>
    )
};

export default ShippingAddress;
